import React from "react";
import { Alert, Box, Button, InputAdornment, TextField } from "@mui/material";
import { LoginForm } from "./utils/LoginUtils";
import { Email } from "@mui/icons-material";

type ForgotPasswordProps = {
  handleSendForgotPasswordEmail: (email: string) => void;
  handleBackToLogin: () => void;
  errorMessage: string | null;
  successMessage: string | null;
  translations: any;
  userEmail: string;
};


const ForgotPassword: React.FC<ForgotPasswordProps> = ({
    handleSendForgotPasswordEmail,
    handleBackToLogin,
    errorMessage,
    successMessage,
    translations,
    userEmail
})  => {

    const [email, setEmail] = React.useState(userEmail);
    

    return (
        <LoginForm elevation={3}>
            {successMessage ? (
                <>
                <Box mb={2}>
                    <Alert severity="success">{successMessage}</Alert>
                </Box>
                <Box textAlign="center">
                        <Button
                        variant="contained"
                        style={{ backgroundColor: 'rgba(0, 192, 239, 1)', color: 'white', padding: '8px 64px' }}
                        onClick={handleBackToLogin}
                    >
                        {translations.back_to_login}
                    </Button>
                </Box>
                </>
            ) : (
                <>
                <Box mb={2} mt={2}>
                <TextField
                        fullWidth
                        label={translations.email}
                        variant="outlined"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Email />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
                {errorMessage && (
                    <Box mb={2}>
                        <Alert severity="error">{errorMessage}</Alert>
                    </Box>
                )}
                <Box textAlign="center">
                    <Button
                        variant="contained"
                        style={{ backgroundColor: 'rgba(176, 177, 177, 1)', color: 'white', padding: '8px 64px' }}
                        onClick={handleBackToLogin}
                    >
                        {translations.cancel}
                    </Button>
                    {"  "}
                    <Button
                        variant="contained"
                        style={{ backgroundColor: 'rgba(0, 192, 239, 1)', color: 'white', padding: '8px 64px' }}
                        onClick={() => handleSendForgotPasswordEmail(email)}
                    >
                        {translations.send}
                    </Button>
                </Box>
            </>
            )}
            
        </LoginForm>
    );
};

export default ForgotPassword;